import {Component, NgZone} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {TAction, TPaybookTipo, TPaybookModo, TAcessoFind, TProfileFlag, TConviteTipo, TDevicerScan} from "../../../app/enum";
import {CONFIG} from "../../../app/config";

import {LogadoService} from "../../../providers/logado-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {HotspotRepository} from "../../../repositories/hotspot-repository";
import {DataService} from '../../../providers/data-service';
import {TConviteSeta, TConviteShow} from '../../../components/app-convite/app-convite';
import {EntrakiService} from '../../../providers/entraki-service';
import {MessageService} from '../../../providers/message-service';
import {MethodoMenuPage} from '../methodo-menu/methodo-menu';
import {Subscription} from 'rxjs/Subscription';

@Component({
    selector: 'page-entraki-open',
    templateUrl: 'entraki-open.html',
    providers: [HotspotService, HotspotRepository, EntrakiService]
})
export class EntrakiOpenPage {

    public subscription: Subscription;
    
    TProfileFlag: any = TProfileFlag;
    TConviteTipo: any = TConviteTipo;
    TConviteSeta: any = TConviteSeta;
    TPaybookTipo: any = TPaybookTipo;
    TConviteShow: any = TConviteShow;

    config: any;
    logado: any;

    selected: number = -1;

    etapa: number;
    paybook: any;
    paybookTipo: TPaybookTipo;
    paybookModo: TPaybookModo;
    profileDesk: any;
    profileLock: boolean;
    userset: any;
    _loading: boolean; 

    conviteShow: TConviteShow;
    tecladoNoro: number = 0;
    checkinSelf: boolean;
    conviteTipo: TConviteTipo;
    monitorBool: boolean;
    comandaID: number;
    spotdayID: number;

    hardwareNfc = (window as any).handappMainInstance.escutarBool && window.innerHeight >= 700;

    hotspot: any;


    voucherNome: string = '';


    //NFC Gravar numero de comanda!
    milhareNoro: number = 1000;
    gravadoNoro: number;
    gravadoJoin: number;

    constructor(public navParams: NavParams, public viewCtrl: ViewController, public util: Util,
                public navCtrl: NavController,
                public logadoService: LogadoService,
                public dataService: DataService,
                public ngZone: NgZone,
                public entrakiService: EntrakiService,
                public messageService: MessageService,
                public hotspotService: HotspotService, public hotspotRepository: HotspotRepository) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Entraki', '/entraki-open');

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.paybook = this.navParams.get('paybook');
        this.paybookTipo = this.navParams.get('paybookTipo');
        this.paybookModo = this.navParams.get('paybookModo');
        this.profileDesk = this.navParams.get('profileDesk');
        this.checkinSelf = this.navParams.get('checkinSelf');
        this.conviteTipo = this.navParams.get('conviteTipo');
        this.monitorBool = this.navParams.get('monitorBool');
        this.tecladoNoro = this.navParams.get('checkinNoro');
        this.userset = this.navParams.get('userset');
        this.spotdayID = this.navParams.get('spotdayID');
        this.comandaID = this.navParams.get('comandaID');

        this.profileLock = (this.profileDesk && (this.profileDesk.ProfileFlag == TProfileFlag.pfBanido || this.profileDesk.ProfileFleg));

        this.hotspot = this.navParams.get('hotspot');
        this.selected = -1;//(this.hotspot && this.hotspot.Ambients.length == 1 ? 0 : -1);

        this.conviteShow = TConviteShow.csLote;

        //if (this.etapa == 0) this.entrakiLoad(false);
        if (this.etapa == 1) this.entrakiLoad(false);

        //Close automatic
        if (this.etapa == 3) this.entrakiExit();

        //Backup Value
        //if (this.etapa == 4) this.paybook.Followe.FolloweTemp = this.paybook.Followe.FolloweStar;
        
        //Checkin pelo usuario vai pedir a comanda!
        this.escutarNear();

    }


    ionViewWillEnter() {

    }

    ionViewDidEnter() {

    }

    statusbar() {

        let style = this.util.stylesBarColor('CorDark');
        this.util.statusBarColor(style);

    }

    brandedTint(negative?) {

        if (this.etapa == 6) return (negative ? 'CorMenu' : 'CorMilk');
        if (this.etapa == 4 && this.checkinSelf) return (negative ? 'CorMenu' : 'CorLime');

        let corcor = (this.hotspot ? this.hotspot.Branded.BrandedCora : this.paybook.Branded.BrandedCora);
        return (negative ? this.config.negative(corcor) : corcor);

//(config.negative(etapa == 4 ? paybook.Branded.BrandedCora : hotspot.Branded.BrandedCora)        
        //(this.hotspot ? this.hotspot.Branded.BrandedCora : this.paybook.Branded.BrandedCora);

    }

    entrakiExit() {

        setTimeout(() => this.dismiss(), 1500);

    }

    entrakiLoad(nextstep: boolean) {

        this._loading = true;

        //GAMB - Para nao bugar o HTML - ion-segment
        this.hotspot.Ambients = null;

        let hotspotID = (this.hotspot ? this.hotspot.HotspotID : 0);
        let profileID = (this.profileDesk ? this.profileDesk.ProfileID : 0);

        // #Ambient
        let request;
        if ( this.monitorBool) request = this.util.monitorDesk(true, 'DESK-Started', hotspotID, '&ProfileID=' + profileID, TAction.acDoor)
      //if (!this.monitorBool) request = this.logadoService.started(TAction.acDoor, hotspotID, this.spotdayID, profileID, '', this.conviteTipo)
        if (!this.monitorBool) request = this.logadoService.started(TAction.acDoor, null, '&HotspotID=' + hotspotID + '&ProfileID=' + profileID + '&SpotdayID=' + this.spotdayID + '&ConviteTipo=' + this.conviteTipo)

        request
            .finally(() => this._loading = false)
            .subscribe(
                data => {
                    this.hotspot.Projeto = data.Projeto;
                    this.hotspot.Ambients = data.Ambients;
                    if (nextstep) this.entrakiNext();

                    //Usuario trabalhando, unico mbiente já vem selecionado!
                    if (this.userset && data.Ambients.length == 1) {
                        this.selected = (this.userset && data.Ambients.length == 1 ? 0 : -1);
                        let convite = this.hotspot.Ambients[this.selected].Convite;
                        if (convite.ConviteSeco > 0 && convite.ConviteSuma == 0) this.conviteSeta(TConviteSeta.csSeco);
                    }
                },
                erro => this.util.alertResult(erro)
            );

    }

    entrakiNext() {

        if ((this.etapa == 1 || this.etapa == 5 || this.etapa == 6) && (!this.checkinSelf || this.hotspot.Followe.FolloweBell)) {
            this.dismiss(this.paybook);
            return;
        }

        this.etapa = this.etapa + 1;

    }

    conviteSeta(conviteSeta: TConviteSeta) {

        this.util.impact();

        let convite = this.hotspot.Ambients[this.selected].Convite;
        convite.conviteSeta = (convite.conviteSeta == conviteSeta ? TConviteSeta.csNone : conviteSeta);
        
    }

    tecladoOkey(btn) {
        
        if (btn == 'ok') {
            if (this.etapa != 9) this.paybookDone();
            if (this.etapa == 9) this.escutarSave(this.gravadoNoro);
        }

        else if (btn == 'cancel') {
            
        }

        else if (btn == 'erase') {
            this.tecladoNoro = 0;
        }

        else if (btn == 'left-thin') {
            let length = this.tecladoNoro+''.length;
            if (length == 1) this.tecladoNoro = 0;
            if (length > 1)  this.tecladoNoro = parseInt(this.tecladoNoro+''.slice(0, length-1));
        }

        else if (btn == 'dot') {
            //
        }

        else if ((this.tecladoNoro+'').length < 5) {
            this.tecladoNoro = parseInt(this.tecladoNoro + (btn + ''));
        }

        if (this.etapa == 9) this.gravadoNoro = this.tecladoNoro;

    }

    escutaScan() {

        (window as any).handappMainInstance.escutarScan();

    }

    escutarNear() {

        this.subscription = 
        this.messageService.get(TDevicerScan[TDevicerScan.dsCheckin]).subscribe(
            data => {

                // TELA-DISPONIVEL - Entraki não faz nada | Tela nao esta pedindo comanda!
                if (!this.util.websterOpen || this.checkinSelf || this.etapa != 6) return;

                //console.log(json);
                let json = this.util.jsParse(data);
                if (!json) {
                    this.util.alertSimply(data, 'JSON ERROR');
                    return;
                }

                //comandaScan - Enter
                if (json.ComandaNoro) {
                    this.paybookModo = TPaybookModo.pmNear;
                    this.tecladoNoro = json.ComandaNoro;
                    this.paybookDone();    
                }

            }
        );

        (window as any).handappMainInstance.escutarTela(TDevicerScan.dsCheckin);

    }


    conviteMore() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Antecipado', handler: () => this.conviteView(TConviteShow.csLoja)});
        buttons.push({text: 'Escolher',   handler: () => this.conviteView(TConviteShow.csList)});
        buttons.push({text: 'Digitar',    handler: () => this.conviteView(TConviteShow.csNovo)});
        this.util.sheetOpen(buttons, 'LOTE');

    }

    conviteView(conviteShow: TConviteShow) {

        this.conviteShow = conviteShow;

    }

    conviteItem(conviteSuma) {

        let convite = this.hotspot.Ambients[this.selected].Convite;
        convite.conviteSeta = TConviteSeta.csSuma;
        convite.ConviteSeco = 0;
        convite.ConviteSuga = 0;
        convite.ConviteSuma = parseInt(conviteSuma);

    }

    paybookHide(paybookHide: boolean) {

        let onNext = (data) => {

            if (data.Comandas && data.Comandas.length) {
                this.dismiss(data.Comandas[0]);
                return;
            }

            this.hotspot.PaybookHide = paybookHide;
            this.entrakiLoad(true);

        }


        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaText=' + this.logado.Profile.ProfileRnid +
                     '&ComandaMode=' + TAcessoFind.afFindRnid;
        this.util.monitorDesk(false, 'DESK-Comanda', this.hotspot.HotspotID, params, TAction.acFind)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onNext(data),
                erro => this.util.alertResult(erro));

    }

    methodoMenu() {

        let paybookCash = 0;
        let conviteNovo = this.hotspot.Ambients[this.selected].Convite;
        if (conviteNovo.conviteSeta == TConviteSeta.csSeco) paybookCash = conviteNovo.ConviteSeco;
        if (conviteNovo.conviteSeta == TConviteSeta.csSuma) paybookCash = conviteNovo.ConviteSuma;

        //Comanda - Fecha a janela
        let onThen = () => {}//#BRIDGE -> this.navCtrl.getPrevious().dismiss();
        let object = {etapa: 0, monitorBool: this.monitorBool, hotspotID: 0, userset: this.userset, rootComanda: {Comandas: [{ComandaID: 0, PaybookCash: paybookCash}]}};
        this.util.modalopen(MethodoMenuPage, 'alto', false, object, null, null, null, onThen).subscribe(
            data => this.paybookCria(data)
        );

    }

    paybookDone() {

        let convite = this.hotspot.Ambients[this.selected].Convite;
        convite.VoucherSeta = convite.conviteSeta;

        //#VIPFREE - Tagfree
        if (!this.checkinSelf && !this.comandaID && !this.voucherNome && !this.spotdayID && convite.conviteSeta == TConviteSeta.csFree) {
            this.voucherNome = 'Cortesia';
            this.etapa = 5;
            return;
        }

        //#COMANDA - Numero
        if (!this.checkinSelf && !this.comandaID && !this.tecladoNoro && !this.spotdayID) {
            this.etapa = 6;
            return;
        }

        //#CREDITO - Pagar convite de comanda pre-paga "ComandaPrey" | "PaybookPrey" | "ConvitePrey"
        if (!this.checkinSelf && !this.comandaID && this.tecladoNoro && !this.spotdayID && this.hotspot.SettingPrey && this.conviteShow != TConviteShow.csLoja) {
            this.methodoMenu();
            return;
        }

        // ** PURCHASE  ** //
        let free = (convite.conviteSeta == TConviteSeta.csFree);
        let door = (convite.ConviteDoor && this.conviteTipo == TConviteTipo.ctConvitePorta);
        let sale = (convite.ConviteSale && this.conviteTipo >= TConviteTipo.ctConviteLista && !free);
        let list = (convite.ConviteList && this.conviteTipo == TConviteTipo.ctConviteLista && !sale);


        if (Number(door) + Number(list) + Number(sale) != 1) {
            this.util.alertSimply('Selecione um convite de ' + TConviteTipo[this.conviteTipo].slice(9, 99));
            return;
        }

        //#GAMBI para carregar a comanda
        this.paybook = {};
        if (door) this.paybookCria(null); //this.entrakiNext();
        if (list) this.voucherList();
        if (sale) this.voucherSale();
        //#GAMBI para carregar a comanda



        //this.paybookCria(null);

    }

    voucherSale() {

        let ambientSeta = this.hotspot.Ambients[this.selected];
        this.dismiss(ambientSeta);

    }

    voucherList() {
        
        let convite = this.hotspot.Ambients[this.selected].Convite;
        let hotspotID = this.hotspot.HotspotID;
        let ambientID = this.hotspot.Ambients[this.selected].AmbientID;
        let usuarioID = 0;

        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.voucher(TAction.acSave, hotspotID, this.logado.Profile.ProfileID, '', 0, ambientID, usuarioID, this.spotdayID, 0, '', convite)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.logadoService.voucherQtde(1);
                    this.dismiss({Codigo: data.Codigo});
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    paybookCria(payments) {
        
        let door = (this.conviteShow == TConviteShow.csLoja);
        let ambient = this.hotspot.Ambients[this.selected];
        let conviteNovo = this.hotspot.Ambients[this.selected].Convite;
        let voucherNome = (this.voucherNome ? '#' + this.voucherNome : '');
        let voucherNovo = {Ambient: ambient, VoucherNome: voucherNome, VoucherSeco: 0, VoucherSuga: 0, VoucherZera: 0, VoucherGorj: 0, VoucherDoor: door, Payments: payments};

        if (conviteNovo.conviteSeta == TConviteSeta.csSeco) {
            voucherNovo.VoucherSeco = conviteNovo.ConviteSeco;
            voucherNovo.VoucherSuga = 0;
        }

        if (conviteNovo.conviteSeta == TConviteSeta.csSuma) {
            voucherNovo.VoucherSeco = (conviteNovo.ConviteSuga ? conviteNovo.ConviteSuma-conviteNovo.ConviteSuga : 0);
            voucherNovo.VoucherSuga = (conviteNovo.ConviteSuga ? conviteNovo.ConviteSuga : conviteNovo.ConviteSuma);
        }


        // let paycria = {
        //     HotspotID: this.hotspot.HotspotID,
        //     GeradorID: 0,
        //     //Branded: this.akkjson.hotwork.Hotspot.Branded,
        //     Promote: null,
        //     Projeto: {ProjetoID: 1000, ProjetoNome: 'Fake'},
        //     Profile: this.profileDesk,

        //     PaybookID: 0,
        //     PaybookSide: TFinanceSide.cdCredito,
        //     PaybookFato: TPaybookFato.ctVencer,
        //     PaybookTipo: this.paybookTipo,
        //     PaybookModo: this.paybookModo,
        //     PaybookNoro: this.tecladoNoro,
        //     PaybookHide: false,
        //     PaybookPrey: this.hotspot.SettingPrey,
        //     PaybookParc: 0,
        //     PaybookBase: this.util.dateToStr(null, false),
        //     PaybookCria: this.util.dateToStr(null, true),
        //     PaybookBora: '',
        //     PaybookText: '',

        //     Consumos: [],
        //     Parcelas: [],
        //     Invoices: [],
        // };

        let onDone = (data) => {
            this.paybook = {};
            this.paybook.HotspotID = this.hotspot.HotspotID;
            this.paybook.PaybookID = data.Codigo;
            this.paybook.Voucher = voucherNovo;
            this.paybook.Profile = this.util.deepCopy(this.profileDesk);
            this.paybook.Followe = {};
            this.entrakiNext();
            //this.dismiss(this.paybook);
        };

        let loading = this.util.loadingDots();
        loading.present();

        //Bridging...
        // this.hotspotService.paybook(TAction.acCria, 0, 0, 0, 0, '', this.paybook)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => onDone(data),
        //         erro => this.util.alertResult(erro)
        //     );

        let profileRnid = (this.profileDesk ? this.profileDesk.ProfileRnid : '');
        let action = (this.comandaID ? TAction.acDoor : TAction.acOpen);
        let params = '';
        let json = voucherNovo;
        if (!this.comandaID) params = '&ProfileRnid=' + profileRnid + '&ComandaNoro=' + this.tecladoNoro + '&ComandaTipo=' + this.paybookTipo + '&ComandaModo=' + this.paybookModo + '&ComandaPrey=' + this.hotspot.SettingPrey;
        if ( this.comandaID) params = '&ComandaID=' + this.comandaID;
        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', this.hotspot.HotspotID, params, action, json, 15000)
            .finally(() => loading.dismiss())
            .subscribe(
                root => onDone(root),
                erro => this.util.alertResult(erro));

    }

    followeBell(event, star) {

        if (this.logado.Profile.ProfileID != this.paybook.Profile.ProfileID) {
            event.cancelLoader();
            return;
        }

        let onBell = () => {

            event.cancelLoader();
            this.paybook.Followe.FolloweStar = star;
            
            //Está em CheckinMenuPage
            if (this.dataService.get('tabselected') == 1) setTimeout(() => this.dismiss(this.paybook), 500);

            setTimeout(() => this.ngZone.run(() => {}), 100);
        }

        let profileID = this.paybook.Profile.ProfileID;

        this.hotspotRepository.followe(event, this.paybook, profileID)
        .subscribe(
            data => onBell(),
            erro => this.util.alertResult(erro),
        );

    }

    followeStar(event, star) {

        if (this.logado.Profile.ProfileID != this.paybook.Profile.ProfileID) {
            event.cancelLoader();
            return;
        }

        let onStar = () => {
            event.cancelLoader();
            this.paybook.Followe.FolloweStar = star;
            
            //Está em CheckinMenuPage
            if (this.dataService.get('tabselected') == 1) setTimeout(() => this.dismiss(this.paybook), 500);

            setTimeout(() => this.ngZone.run(() => {}), 100);
        }

        let bool = true;//(followe.FolloweTemp != followe.FolloweStar);
        let profileID = this.paybook.Profile.ProfileID; //trocar para this.paybook.Followe.HotspotID
        if (bool) this.hotspotService.followe(TAction.acStar, this.paybook.HotspotID, profileID, {FolloweStar: star}).subscribe(data => onStar());

    }

    profileEdit() {

    }
    
    dismiss(paybook?) {

        //Checkin pelo usuario volta escutar Workday!
        let escutarTela = (this.util.websterOpen ? TDevicerScan.dsWorkday : TDevicerScan.dsEntraki);
        (window as any).handappMainInstance.escutarTela(escutarTela);

        //Unregister Escutar
        this.subscription.unsubscribe();

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(paybook);
        }

        if (!this.viewCtrl.isOverlay) {
            this.navCtrl.pop({animation: 'md-transition'});
        }

    }







    comandaMany() {

        let onPick = (milha) => {
            this.milhareNoro = milha;
            this.gravadoNoro = milha;
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Digitar', value: 0});

        let index = 1;
        for (let i = 0; i < 180; i++) {
            let line = (i*50)+1000;
            if (line == this.milhareNoro) index = i + 1;
            buttons.push({text: line, value: line});
        }

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = index;
        this.util.pickerOpen(columns, onPick);

    }

    comandaNoro() {

        let list = [];
        if (this.milhareNoro == 0) return list;

        for (let i = this.milhareNoro; i < (this.milhareNoro + 50); i++) list.push(i);

        return list;
        
    }

    escutarSave(comandaNoro) {

        this.gravadoNoro = comandaNoro;
        (window as any).handappMainInstance.escutarSave('Comanda', comandaNoro);

    }


}




// WEBPACK FOOTER //
// ./src/pages/sync/entraki-open/entraki-open.ts